import React from "react";
import "./TableButtons.css";

/**
 * CancelRowButton - X mark button for canceling inline table edits
 * 
 * @example
 * <CancelRowButton onClick={handleCancel} />
 */
const CancelRowButton = ({ onClick, disabled = false, ariaLabel = "Cancel edit", ...props }) => {
  return (
    <button
      className="cancel-row"
      onClick={onClick}
      disabled={disabled}
      aria-label={ariaLabel}
      title="Cancel"
      {...props}
    >
      ✕
    </button>
  );
};

export default CancelRowButton;

